import { useQuery } from '@apollo/client/react';
import { Box } from '@utilitywarehouse/hearth-react';
import { useSearchParams } from 'react-router-dom';

import { CURRENCY_CODE } from '@constants/app';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useTrackingContextRefresh } from '@tracking/hooks';
import { getBundleBasket } from '@utils/queries/getBasket';

import { DepositDetailsForm } from './DetailsForm';
import { useDepositPrivacySnackbar } from './useDepositPrivacySnackbar';
import { useSubmitDepositOrder } from './useSubmitDepositOrder';

const DepositDetails = () => {
  const { basketId } = useBasketContext();

  useDepositPrivacySnackbar();

  const { data, loading: basketLoading } = useQuery(getBundleBasket, {
    variables: { basketId },
  });
  // Ensures that the tracking context is set after page refresh
  useTrackingContextRefresh()(data, basketLoading);

  // TODO: What should the behavior of this page be if these values are empty,
  //  theoretically it shouldn't have got to this page...
  // TODO: DB returns `CURRENCY_GBP` which isn't compatible with the formatCurrency function which expects GBP,
  //  could split the string, but it feels like there should be a better way
  const depositCurrency = CURRENCY_CODE;
  const depositValue =
    data?.basket?.depositRequirement?.depositAmount.value || '';

  const {
    handleSubmitDeposit,
    isLoading: submitDepositLoading,
    error,
    submitDepositData,
  } = useSubmitDepositOrder(depositValue, depositCurrency);

  // Payments will be redirected to this page, if so there will be a transaction_token in the querystring of the url
  // passing this into the deposit form will display the correct Spreedly response in the iframe create in the
  // ProcessPayment component
  const [searchParams] = useSearchParams();
  const transaction_token = searchParams.get('transaction_token');

  let transaction_token_string;
  if (transaction_token !== undefined) {
    transaction_token_string = transaction_token as string;
  }

  return (
    <Box paddingBottom="500">
      <section className="wrapper">
        <DepositDetailsForm
          depositDataCurrency={depositCurrency}
          depositDataValue={depositValue}
          submitDeposit={handleSubmitDeposit}
          basketID={basketId}
          submitDepositData={submitDepositData}
          submitDepositError={error}
          submitDepositLoading={submitDepositLoading || basketLoading}
          redirectTransactionToken={transaction_token_string}
        />
      </section>
    </Box>
  );
};

export { DepositDetails };
